import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

/**
 * Servizio per controllare il routing
 */
@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
    ) { }

    canActivate(query: ActivatedRouteSnapshot) {
        if (query.queryParams.cID) {
            return true;
        }
        this.router.navigate(['/']);
        return false;
    }
}
